import { render, staticRenderFns } from "./PresentationOverlay.vue?vue&type=template&id=706f2ec2&scoped=true"
import script from "./PresentationOverlay.vue?vue&type=script&lang=js"
export * from "./PresentationOverlay.vue?vue&type=script&lang=js"
import style0 from "./PresentationOverlay.vue?vue&type=style&index=0&id=706f2ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706f2ec2",
  null
  
)

export default component.exports